/// <reference path="../types/index.d.ts" />

import '../client_forms/boldamerican6/style.css';
import FormStructure from './boldamerican6/form_structure';

export default FormStructure;